
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Editable from '@/components/Editable'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"editable-component"}}>{`Editable Component`}</MDXTag>
<MDXTag name="p" components={components}>{`The `}<MDXTag name="inlineCode" components={components} parentName="p">{`Editable`}</MDXTag>{` component is a generic editor for most data types.`}</MDXTag>
<style>{`
  .editable {
    border: 1px solid #ddd;
    padding: .25em;
  }
`}</style>
<MDXTag name="h3" components={components} props={{"id":"boolean"}}>{`Boolean`}</MDXTag>
<Playground __position={1} __code={'<Editable value={true} />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value={true} />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"numeric"}}>{`Numeric`}</MDXTag>
<Playground __position={2} __code={'<Editable value={4} />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value={4} />
</Playground>
<MDXTag name="h4" components={components} props={{"id":"numeric-constrained-to-a-range"}}>{`Numeric (constrained to a range)`}</MDXTag>
<Playground __position={3} __code={'<Editable value={10} max={20} min={0} step={2} />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value={10} max={20} min={0} step={2} />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"range"}}>{`Range`}</MDXTag>
<Playground __position={4} __code={'<Editable value={50} max={100} type=\"slider\" />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value={50} max={100} type="slider" />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"string"}}>{`String`}</MDXTag>
<Playground __position={5} __code={'<Editable value=\"Single Line String\" />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value="Single Line String" />
</Playground>
<MDXTag name="h3" components={components} props={{"id":"multi-line-string"}}>{`Multi-Line String`}</MDXTag>
<Playground __position={6} __code={'<Editable value=\"Multi-Line String\" type=\"multiline\" />'} __scope={{props: this ? this.props : props,Editable}}>
  <Editable value="Multi-Line String" type="multiline" />
</Playground>
           </MDXTag>
  }
}
  